module.exports = __webpack_public_path__ + "img/brick-magic-logo.42d6ad91.png";